export default __webpack_public_path__ + "static/media/send.606b348d.svg";